<template>
    <gridComponent :loader="loader" :items="items" :itemsData="itemsData" :headers="headers"
        :colonneWidth="colonneWidth" :GetFunction="fetchDeliveryOrders">
        <!-- Filter for deliveryPersonId -->
        <template v-slot:[SlotsFilters.Filter0]="{ index }">
            <ColumnFilter :title="$t('Delivery.deliveryPersonId')" :Filter="filters.SearchTitle"
                :getList="fetchDeliveryPersons" @cancel="filters.SearchDeliveryPersonId = null" :index="index">
                <template v-slot:input>
                    <v-text-field v-model="filters.SearchTitle" id="deliveryPersonId" variant="outlined" maxlength="50"
                        hide-details></v-text-field>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsFilters.Filter1]="{ index }">
            <ColumnFilter :title="$t('Delivery.fullName')" :Filter="filters.SearchFullName"
                :getList="fetchDeliveryPersons" @cancel="filters.SearchFullName = null" :index="index">
                <template v-slot:input>
                    <v-text-field v-model="filters.SearchFullName" id="fullName" variant="outlined" maxlength="50"
                        hide-details></v-text-field>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsFilters.Filter2]="{ index }">
            <ColumnFilter :title="$t('Delivery.phone')" :Filter="filters.SearchPhone" :getList="fetchDeliveryPersons"
                @cancel="filters.SearchPhone = null" :index="index">
                <template v-slot:input>
                    <v-text-field v-model="filters.SearchPhone" id="phone" variant="outlined" maxlength="15"
                        hide-details></v-text-field>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsFilters.Filter3]="{ index }">
            <ColumnFilter :title="$t('Delivery.status')" :Filter="filters.SearchIsActive"
                :getList="fetchDeliveryPersons" @cancel="filters.SearchIsActive = null" :index="index">
                <template v-slot:input>
                    <v-select v-model="filters.SearchIsActive" :items="[true, false]"
                        :item-title="item => (item ? $t('common.active') : $t('common.inactive'))" variant="outlined"
                        hide-details></v-select>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsItems.item0]="{ item }">{{ item.title }}</template>
        <template v-slot:[SlotsItems.item1]="{ item }">{{ item.quantity }}</template>
        <template v-slot:[SlotsItems.item2]="{ item }">{{ formatPrice(item.price) }}</template>
        <template v-slot:[SlotsItems.item3]="{ item }">{{ item.tax }}</template>
        <template v-slot:[SlotsItems.item4]="{ item }">
            <StatusButton :title="getStatusLabel(item.isAccepted)" :color="getStatusColor(item.isAccepted)" />
        </template>
        <template v-slot:edit="{ item, index }">
            <DelvriesActionMenu :Id="index" v-bind:idBrand="item.brandId" v-bind:getBrand="item"
                v-bind:getBrandListAfterDelete="BrandsList" />
        </template>
    </gridComponent>
</template>

<script>
import { formatPrice, getBrands } from '@/api/index';
import GridComponent from '@/genericComponent/gridComponent.vue';
import ColumnFilter from '@/genericComponent/ColumnFilter.vue';
import StatusButton from '@/genericComponent/StatusButton.vue';
import DelvriesActionMenu from '../DelvriesActionMenu.vue'
import { getDeliveryOrdersByCompanyId } from "@/api/index";
export default {
    components: { StatusButton, GridComponent, ColumnFilter, DelvriesActionMenu },
    props: {
        companyId: {
            type: String,
            required: true,
        },
    },
    mounted() {
        this.fetchDeliveryOrders();
        this.emitter.emit('remise-search-at-null');
        this.emitter.on('event-test', (event) => {
            this.search = event;
        });
    },
    unmounted() {
        this.emitter.off('event-test');
        this.emitter.emit('remise-search-at-null');
    },
    data() {
        return {
            loader: true,
            page: 1,
            PageSize: 10,
            items: {},
            itemsData: {},
            filters: {
                SearchTitle: null,
                SearchQuantity: null,
                SearchTax: null,
                SearchPrice: null,
            },
            search: null,
            brandName: null,
            FieldCategoryId: [],
            FieldCreatedDateFrom: null,
            FieldCreatedDateTo: null,
            FieldSupplierId: null,
            SortedBy: null,
            SortingType: null,
            localShowFilterDialog: this.showFilterDialog,
            item: null,
            categories: [],
        }
    },
    methods: {
        formatPrice(price) {
            return formatPrice(price)
        },
        fetchDeliveryOrders(page = this.page) {
            this.loader = true;
            const params = {
                PageNumber: page,
                PageSize: this.PageSize,
                SortBy: this.SortedBy,
                SortDescending: this.SortingType,
                SearchTerm: this.filters.SearchTerm || '',
                SearchTitle: this.filters.SearchTitle || '',
                SearchQuantity: this.filters.SearchQuantity || null,
                SearchPrice: this.filters.SearchPrice || null,
                SearchTax: this.filters.SearchTax || null,
            };

            getDeliveryOrdersByCompanyId(this.companyId, params)
                .then((response) => {
                    this.items = response.data.items;
                    this.itemsData = {
                        totalPages: response.data.totalPages,
                        totalCount: response.data.totalCount,
                        pageNumber: response.data.pageNumber,
                        hasPreviousPage: response.data.hasPreviousPage,
                        hasNextPage: response.data.hasNextPage,
                    };
                })
                .catch((error) => {
                    console.error("Error fetching delivery orders:", error);
                })
                .finally(() => {
                    this.loader = false;
                });
        },
        getStatusLabel(isActif) {
            return isActif ? this.$t('common.active') : this.$t('common.inactive');
        },
        getStatusColor(isActif) {
            return isActif ? '#3BBAFF' : '#F25C5C';
        },
        BrandsList: function (page) {
            if (page) { this.page = page }
            getBrands(this.page, this.PageSize, this.brandName, this.FieldCategoryId, this.FieldSupplierId, this.FieldCreatedDateFrom, this.FieldCreatedDateTo, this.SortedBy, this.SortingType).then((response) => {
                this.items = response.data.items;
                this.itemsData.numberOfPage = response.data.totalPages;
                this.itemsData.totalItemsCount = response.data.totalCount;
                this.itemsData.pageNumber = response.data.pageNumber;
                this.itemsData.hasPreviousPage = response.data.hasPreviousPage;
                this.itemsData.hasNextPage = response.data.hasNextPage;
                this.loader = false;
            });
        },
        handleCancel() {
            this.localShowFilterDialog = false;
        },
        handleConfirm(filteredParams) {
            this.brandName = filteredParams.BrandName;
            this.FieldCategoryId = filteredParams.IdCategories;
            this.FieldSupplierId = filteredParams.supplierId;
            this.FieldCreatedDateFrom = filteredParams.CreatedFrom;
            this.FieldCreatedDateTo = filteredParams.CreatedTo;
            this.BrandsList();
            this.localShowFilterDialog = false;
        },
    },
    watch: {
        showFilterDialog(value) {
            this.localShowFilterDialog = value;
        },
    },
    computed: {
        flattenedCategories() {
            const flatten = (cats, parentId = null, level = 0) => {
                return cats.reduce((acc, category) => {
                    if (category.parent_category_id === parentId) {
                        const flatCategory = {
                            ...category,
                            name: "  ".repeat(level) + category.name,
                        };
                        acc.push(flatCategory);
                        acc.push(...flatten(cats, category.categoryId, level + 1));
                    }
                    return acc;
                }, []);
            };
            return flatten(this.categories);
        },
        headers() {
            const headers = [
                this.$t('Delivery.Order.Title'),
                this.$t('Delivery.Order.Quantity'),
                this.$t('Delivery.Order.Price'),
                this.$t('Delivery.Order.Tax'),
                this.$t('Delivery.status'),
            ];
            return headers;
        },
        SlotsItems() {
            const items = {
                item0: 'item',
                item1: 'item',
                item2: 'item',
                item3: 'item',
                item4: 'item',
            }
            let i = 0;
            for (const key in items) {
                items[key] = 'item' + i;
                i = i + 1;
            }
            return items;
        },
        SlotsFilters() {
            const filters = {
                Filter0: 'Filter',
                Filter1: 'Filter',
                Filter2: 'Filter',
                Filter3: 'Filter',
                Filter4: 'Filter',
            }
            let i = 0;
            for (const key in filters) {
                filters[key] = 'Filter' + i;
                i = i + 1;
            }
            return filters;
        },
        colonneWidth() {
            const headers = ['20%', '15%', '15%', '20%', '15%'];
            return headers;
        },
    }
};
</script>

<style scoped>
.v-card-title {
    color: #001e50;
    font-size: 18px;
    line-height: 25.5px;
    font-weight: 700;
    font-family: inter;
}

.v-window .v-card-title {
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    color: #5b6d8e;
    margin-left: 12px;
    margin-bottom: 5px;
}

.slider {
    color: #667280;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    flex: content;
    pointer-events: none;
    border: none;
}
</style>
